import React from "react";
import { Button, Card, Table, Tag, Typography, message } from "antd";
import { useNavigate } from "react-router-dom";
import { useContext } from "react";
import { ProfileContext } from "Common/hooks/context/ProfileContext";
import api from "Common/Client/Interceptor";
import useServerPagination from "Common/hooks/useServerPagination";
const { Text } = Typography;

// Fetch a page of the learner's training groups.
const fetchTrainingGroups = async ({ pageNumber, pageSize, orderByLatest }) => {
  const learnerId = localStorage.getItem("personalId");
  const response = await api.get("/TrainingGroup/Learner/List", {
    params: { LearnerId: learnerId, pageNumber, pageSize, orderByLatest },
  });
  return response.data;
};

const TrainingGroup = () => {
  const navigate = useNavigate();
  const { isProfileComplete } = useContext(ProfileContext);
  const isBlocked = !isProfileComplete;
  const {
    items: groupData,
    loading: loadingGroups,
    paginationProps,
  } = useServerPagination(fetchTrainingGroups, {}, {
    onError: (err) => message.error(err?.message || "Failed to load training groups"),
  });
  const columns = [
    {
      title: "Group Name",
      dataIndex: "groupName",
      key: "groupName",
      render: (text, record) => (
        <div style={{ position: "relative", display: "flex", alignItems: "center" }}>
          <Text strong>{text}</Text>
          {record.isRetryTraining && (
            <Tag color="orange" style={{ marginLeft: 8, fontWeight: "bold" }}>
              Repeated
            </Tag>
          )}
        </div>
      ),
    },
    {
      title: "Created On",
      dataIndex: "createdOn",
      key: "createdOn",
      render: (text) => new Date(text).toLocaleString(),
    },
    {
      title: "Members Count",
      dataIndex: "membersCount",
      key: "membersCount",
    },
    {
      title: "Actions",
      key: "actions",
      render: (_, record) => (
        <Button type="link" disabled={isBlocked} onClick={() => !isBlocked && navigate(`/group-detail/${record.id}`)}>
          View Detail
        </Button>
      ),
    },
  ];
  return (
    <Card loading={loadingGroups} title="Trainings Group" className="card-professional">
      <Table columns={columns} dataSource={groupData} rowKey="id" pagination={paginationProps} scroll={{ x: "max-content" }} />
    </Card>
  );
};
export default TrainingGroup;
